import { useState, useEffect } from "react";

interface SelectedRetailerInfo {
    chainName?: string;
    dealerCode: string;
    dealerId: number;
    dealerName: string;
    isManager?: boolean;
}

const LOCAL_STORAGE_KEY = "selected_retailer";

export const useSelectedRetailer = () => {
    const [selectedRetailer, setSelectedRetailer] = useState<SelectedRetailerInfo | null>(null);

    useEffect(() => {
        const loadSelectedRetailer = () => {
            const savedShop = localStorage.getItem(LOCAL_STORAGE_KEY);
            if (savedShop) {
                const shopInfo: SelectedRetailerInfo = JSON.parse(savedShop);
                setSelectedRetailer(shopInfo);
            }
        };

        loadSelectedRetailer();
    }, []);

    const saveSelectedRetailer = (retailer: SelectedRetailerInfo) => {
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(retailer));
        setSelectedRetailer(retailer);
    };

    return {
        selectedRetailer,
        saveSelectedRetailer,
    };
};
